module.exports = __webpack_public_path__ + "static/NightInTheWoods8-bc42b98ee76bebce523a34bc289cff57.png";